const getViewParams = (state) => state.get('view');

export const isFiltersHidden = (state) =>
  getViewParams(state).get('hideSidebar');
export const getMobilePlatform = (state) =>
  getViewParams(state).get('platform');
export const getIsWhitelabel = (state) =>
  getViewParams(state).get('isWhitelabel');
export const getIsAdmin = (state) => getViewParams(state).get('isAdmin');
export const getIsSubscribeShown = (state) =>
  getViewParams(state).get('showSubscribePopup');
export const getIsMetaregion = (state) =>
  getViewParams(state).get('isMetaregion');
